import { ClientError } from "graphql-request";

// `ClientError.message` has the whole serialised request appended to it - query
// text and variables included - so it must never be shown to a user as-is.
export function parseMutationErrorMessage(error: unknown): string {
  if (!(error instanceof ClientError)) {
    return error instanceof Error ? error.message : String(error);
  }

  return (
    error.response.errors?.[0]?.message ??
    parseErrorMessageField(error.response.body) ??
    stripSerialisedRequest(error.message)
  );
}

function parseErrorMessageField(body: string | undefined): string | undefined {
  if (!body) {
    return undefined;
  }
  try {
    const parsed = JSON.parse(body) as { ErrorMessage?: unknown } | null;
    return typeof parsed?.ErrorMessage === "string"
      ? parsed.ErrorMessage
      : undefined;
  } catch {
    return undefined;
  }
}

function stripSerialisedRequest(message: string): string {
  const position = message.search(": {");
  return position > -1 ? message.slice(0, position) : message;
}
